<template>
  <app-dialer-common-popup
    class="app-dialer-call-members-popup"
    :title="title"
    :is-loading="isLoading"
    :is-disabled="isDisabled"
    @close="$emit('close')"
  >
    <simplebar style="width: 100%;">
      <base-item
        v-for="member of members"
        :key="member.memberId"
        :avatar="avatar"
        :person="getPerson(member)"
        :title="getMemberName(member)"
        :description="getMemberIdentifierLabel(member)"
        :status="getMemberStatusLabel(member)"
        :status-type="getMemberStatusType(member)"
        :actions="getMemberOptions(member)"
        :show-action-icons="true"
        :is-disabled="isDisabled"
        @action-click="onActionClick($event, member)"
      />
    </simplebar>
  </app-dialer-common-popup>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { TranslateResult } from 'vue-i18n';
import Simplebar from 'simplebar-vue';

import { AppDialerCommonPopup } from '../common';
import { BaseItem } from '@/modules/agent-picker';
import { useDialerMembers } from '../../composables';
import { AVATAR_PROP, MEMBERS_PROP } from '../../constants';

export default defineComponent({
  name: 'AppDialerCallMembersPopup',
  components: {
    Simplebar,
    AppDialerCommonPopup,
    BaseItem,
  },
  props: {
    avatar: AVATAR_PROP,
    members: MEMBERS_PROP,
    isLoading: Boolean,
    isDisabled: Boolean,
  },
  emits: ['hang-up', 'close'],
  setup() {
    const {
      getPerson,
      getMemberName,
      getMemberIdentifierLabel,
      getMemberStatusLabel,
      getMemberStatusType,
      getMemberOptions,
      onActionClick,
    } = useDialerMembers();

    return {
      getPerson,
      getMemberName,
      getMemberIdentifierLabel,
      getMemberStatusLabel,
      getMemberStatusType,
      getMemberOptions,
      onActionClick,
    };
  },
  computed: {
    title(): TranslateResult {
      if (this.isLoading) {
        return this.$t('hitl.common.loadingWithDots');
      }

      const data = { count: this.members.length };
      return this.$t('hitl.modules.dialer.call-members-title', data);
    },
  },
});
</script>

<style lang="scss" scoped>
.app-dialer-call-members-popup {
  width: 40rem;

  [data-simplebar] {
    max-height: 15rem;
  }

  ::v-deep .content {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
